import { Observable } from 'rxjs';

export const elementMutate = (
  target: HTMLElement,
  options: MutationObserverInit,
) =>
  new Observable<MutationRecord[]>((subscriber) => {
    const observer = new MutationObserver((mutationsList) => {
      subscriber.next(mutationsList);
    });

    observer.observe(target, options);

    subscriber.add(() => observer.disconnect());
  });
